import { render, staticRenderFns } from "./InsightsLayout.vue?vue&type=template&id=607df532&scoped=true"
import script from "./InsightsLayout.vue?vue&type=script&lang=js"
export * from "./InsightsLayout.vue?vue&type=script&lang=js"
import style0 from "./InsightsLayout.vue?vue&type=style&index=0&id=607df532&prod&lang=scss&scoped=true"
import style1 from "./InsightsLayout.vue?vue&type=style&index=1&id=607df532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607df532",
  null
  
)

export default component.exports